import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ServiciosService } from './servicios.service'; // tu servicio de API

@Injectable({
    providedIn: 'root'
})
export class UserInfoService {

    private userData$ = new BehaviorSubject<any>(null);
    private isLoading$ = new BehaviorSubject<boolean>(false);
    private hasLoadedOnce = false;

    private servicios = inject(ServiciosService);

    constructor() { }

    cargarInfo(forceOrProfile: boolean | any = false) {
        if (this.isProfilePayload(forceOrProfile)) {
            const normalized = this.extractProfileData(forceOrProfile);
            this.userData$.next(normalized);
            this.hasLoadedOnce = true;
            this.isLoading$.next(false);
            return;
        }

        const force = forceOrProfile === true;
        if (!force && (this.hasLoadedOnce || this.userData$.value || this.isLoading$.value)) {
            return;
        }

        this.isLoading$.next(true);
        this.servicios.traerDatos('profile').subscribe({
            next: (resp) => {
                this.userData$.next(resp);
                this.hasLoadedOnce = true;
                this.isLoading$.next(false);
            },
            error: () => {
                this.isLoading$.next(false);
            }
        });
    }

    private isProfilePayload(value: unknown): boolean {
        return typeof value === 'object' && value !== null;
    }

    private extractProfileData(payload: any): any {
        if (payload && typeof payload === 'object' && payload.data && typeof payload.data === 'object') {
            return payload.data;
        }
        return payload;
    }

    getUserData(): Observable<any> {
        return this.userData$.asObservable();
    }

    getLoading(): Observable<boolean> {
        return this.isLoading$.asObservable();
    }

    getUserDataValue(): any {
        return this.userData$.value;
    }
}
